var _path, _path2, _line, _line2, _line3, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecognition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5089 14.2675C14.0224 14.4601 15.6271 15.0378 17.1677 15.0378C18.7082 15.0378 20.1203 14.3959 20.8264 13.8824C21.1345 13.7283 21.5325 13.3047 21.5967 13.3047",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7828 5.98687C17.7456 6.372 18.7084 5.98687 18.7084 5.98687M18.7084 5.98687C18.7084 5.98687 20.249 5.60174 20.249 4.44635C20.249 2.90582 19.4787 2.32812 16.9753 2.32812C14.6645 2.32812 13.5092 2.98127 13.5092 4.44635C13.5092 5.52472 14.5362 6.05106 15.0497 6.17944V9.64562C15.0497 10.6084 13.7251 11.2425 13.3166 11.3787C12.7389 11.5713 11.9686 12.149 11.9686 12.9192C11.9686 13.5354 11.9686 14.8449 11.9686 15.4226C12.1612 16.1287 13.3936 17.5408 16.7828 17.5408C20.1719 17.5408 21.4043 16.1287 21.5969 15.4226V12.9192C21.5969 12.4699 21.5969 11.7638 20.8267 11.3787C19.8991 10.915 18.5159 10.6084 18.5159 9.83819C18.5159 9.22198 18.6507 7.07808 18.7084 5.98687Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.24915,
    y1: 9.23047,
    x2: 10.9112,
    y2: 9.23047,
    stroke: "#081E54",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.8634,
    y1: 11.7715,
    x2: 10.5255,
    y2: 11.7715,
    stroke: "#081E54",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.47864,
    y1: 14.3125,
    x2: 8.21508,
    y2: 14.3125,
    stroke: "#081E54",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.982 19.2601L22.5597 21.5709H0.99231L4.84362 6.55078H12.1611",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecognition);
export default __webpack_public_path__ + "static/media/Recognition.647ac9975b6445b6ec6e13167aec3e8e.svg";
export { ForwardRef as ReactComponent };